import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBKTANMdc7WLY28fRA_fiAm5vUn0yw7L48",
  authDomain: "chavo-tours.firebaseapp.com",
  projectId: "chavo-tours",
  storageBucket: "chavo-tours.firebasestorage.app",
  messagingSenderId: "899377005912",
  appId: "1:899377005912:web:860545fda24cecb104512d"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export
